import React from "react";
import { compareAlpha } from "./sortUtils";
import { FeedBagIcon, HorseIcon, CattleIcon } from "./icons";
import { SYSTEM_LISTS_DEFAULTS } from "./globals";

const SYSTEM_LISTS_LABELS = {
  COST_CENTERS:        {label:"Centros de Custo",        module:"⚙️ Geral",          icon:"🏠"},
  COST_CENTER_CODES:   {label:"Siglas dos Centros de Custo", module:"⚙️ Geral",       icon:"🔠"},
  UNITS:               {label:"Unidades de Medida",      module:"🛒 Compras",         icon:"📏"},
  ANIMAL_SPECIES:      {label:"Espécies",                module:"Pecuária",           icon:"🐾"},
  ANIMAL_STATUS:       {label:"Status do Animal",        module:"Pecuária",           icon:"📋"},
  ANIMAL_BREEDS:       {label:"Raças do Rebanho",        module:"Pecuária",           icon:<CattleIcon size={19} />},
  LOT_PURPOSES:        {label:"Finalidades de Lote",     module:"Pecuária",           icon:"🎯"},
  VET_TYPES:           {label:"Tipos de Atendimento",    module:"🏥 Veterinário",     icon:"💉"},
  FIN_CATS:            {label:"Categorias Financeiras",  module:"💰 Financeiro",      icon:"📊"},
  FIN_CHART_ACCOUNTS:  {label:"Plano de Contas",         module:"💰 Financeiro",      icon:"🧾"},
  PAYROLL_CHARGES:     {label:"Encargos da Folha",       module:"💰 Financeiro",      icon:"👥"},
  TAX_REGIMES:         {label:"Regimes e Tributos",      module:"💰 Financeiro",      icon:"🏛️"},
  BOVINE_WEIGHT_CLASS_RULES:{label:"Faixas de @ do Bovino", module:"Pecuária",        icon:"⚖️"},
  ANIMAL_EXIT_REASONS: {label:"Motivos de Saída Animal", module:"Pecuária",           icon:"🚚"},
  ANIMAL_ENTRY_REASONS:{label:"Motivos de Entrada Animal",module:"Pecuária",          icon:"📥"},
  ANIMAL_BUYER_DEFAULTS:{label:"Compradores de Animais", module:"Pecuária",           icon:"🤝"},
  FUNC_ROLES:          {label:"Cargos",                  module:"👥 RH",              icon:"👤"},
  FUNC_STATUS:         {label:"Status do Colaborador",   module:"👥 RH",              icon:"📋"},
  CATALOG_PRODUCT_TYPES:{label:"Tipos do Catálogo", module:"📦 Estoque", icon:"🧱"},
  GLOBAL_PAYMENT_TERMS:{label:"Prazos", module:"🌐 Globais", icon:"⏳"},
  GLOBAL_PAYMENT_METHODS:{label:"Formas de Pagamento", module:"🌐 Globais", icon:"💳"},
  CATALOG_PRODUCT_CATEGORIES:{label:"Categorias do Catálogo", module:"📦 Estoque", icon:"🗂️"},
  CATALOG_PRODUCT_SUBCATEGORIES:{label:"Subcategorias do Catálogo", module:"📦 Estoque", icon:"🧩"},
  STOCK_UNITS:         {label:"Unidades de Estoque",     module:"📦 Estoque",         icon:"📏"},
  STOCK_BRANDS:        {label:"Marcas de Produtos",      module:"📦 Estoque",         icon:"🏷️"},
  MACH_CATEGORIES:     {label:"Categorias de Maquinário", module:"🚜 Maquinário",      icon:"🗂️"},
  MACH_SUBCATEGORIES:  {label:"Subcategorias de Maquinário", module:"🚜 Maquinário",   icon:"🧩"},
  MACH_BRAND_LINKS:    {label:"Vínculos Marca x Categoria/Subcategoria", module:"🚜 Maquinário", icon:"🏷️"},
  MACH_TYPES:          {label:"Tipos de Maquinário",     module:"🚜 Maquinário",      icon:"🔧"},
  MACH_STATUS:         {label:"Status do Maquinário",    module:"🚜 Maquinário",      icon:"📋"},
  FUEL_TYPES:          {label:"Tipos de Combustível",    module:"🚜 Maquinário",      icon:"⛽"},
  ENGINE_TYPES:        {label:"Tipos de Motor",          module:"🚜 Maquinário",      icon:"⚙️"},
  GRASS_TYPES:         {label:"Tipos de Pastagem",       module:"🗺️ Localização",     icon:"🌿"},
  WEED_LEVELS:         {label:"Níveis de Invasoras",     module:"🗺️ Localização",     icon:"🌾"},
  FEED_TYPES:          {label:"Tipos de Alimentação",    module:"Pecuária",           icon:<FeedBagIcon size={19} />},
  SUPPLEMENT_TYPES:    {label:"Tipos de Suplemento",     module:"Pecuária",           icon:"💊"},
  BIRD_MORTALITY_REASONS:{label:"Motivos de Mortes das Aves", module:"Avicultura", icon:"☠️"},
  TRAINING_TYPES:      {label:"Tipos de Treino",         module:"Haras",           icon:<HorseIcon size={19} />},
  HARAS_FEED_TIMES:    {label:"Horários de Alimentação do Haras", module:"Haras", icon:"🕒"},
  HARAS_MANAGEMENT_TYPES:{label:"Tipos de Manejo do Haras", module:"Haras", icon:"🧹"},
  HARAS_TRAINING_REASONS:{label:"Justificativas de Treino do Haras", module:"Haras", icon:"📝"},
  HARAS_SPECIAL_DIET_REASONS:{label:"Motivos de Dieta Especial do Haras", module:"Haras", icon:"🍽️"},
  HARAS_ACTIVITY_RULES:{label:"Regras de Atividade do Haras", module:"Haras", icon:"📈"},
  HARAS_BREED_RULES:{label:"Regras Nutricionais por Raça do Haras", module:"Haras", icon:"🧬"},
  POI_CATEGORIES:      {label:"Categorias de POI",       module:"🗺️ Localização",     icon:"🧭"},
  HARAS_BREEDS:        {label:"Raças do Haras",          module:"Haras",           icon:<HorseIcon size={19} />},
  HARAS_COATS:         {label:"Pelagens do Haras",       module:"Haras",           icon:"🎨"},
  PROVIDER_SPECIALTIES:{label:"Especialidades Prestador",module:"👷 Prestadores",     icon:"🛠️"},
  DEV_REASONS:         {label:"Motivos Devolução EPI",   module:"👥 RH",              icon:"🦺"},
  EMPLOYEE_DELETE_REASONS:{label:"Motivos de Exclusão de Colaborador", module:"👥 RH", icon:"🗑️"},
  EMPLOYEE_REACTIVATE_REASONS:{label:"Motivos de Reativação de Colaborador", module:"👥 RH", icon:"♻️"},
  POI_STATUSES:        {label:"Status de POI",           module:"🗺️ Localização",     icon:"📍"},
  WATER_STATUS:        {label:"Status da Aguada",        module:"Haras",           icon:"💧"},
  TROUGH_STATUS:       {label:"Status do Cocho",         module:"Haras",           icon:"🪣"},
  BED_THICKNESS:       {label:"Espessura da Cama",       module:"Haras",           icon:"🛏️"},
  BED_MOISTURE:        {label:"Umidade da Cama",         module:"Haras",           icon:"💦"},
  ORDER_DENY_REASONS:  {label:"Justificativas de Negação",  module:"🛒 Compras",    icon:"❌"},
  ORDER_NO_QUOTE_REASONS:{label:"Justificativas sem Cotação",module:"🛒 Compras",    icon:"📝"},
  SERVICE_TITLES:      {label:"Títulos de Serviço",          module:"🔨 Serviços Internos",   icon:"📋"},
  SERVICE_EXEC_TYPES:  {label:"Tipos de Execução",           module:"🔨 Serviços Internos",   icon:"⚙️"},
  SERVICE_PHOTO_TITLES:{label:"Títulos das Fotos de Serviço", module:"🔨 Serviços Internos",   icon:"📷"},
  SERVICE_PAY_METHODS: {label:"Formas de Pagamento",         module:"🔨 Serviços Internos",   icon:"💳"},
  SERVICE_DENY_REASONS:{label:"Motivos de Negação Orçamento",module:"🔨 Serviços Internos",   icon:"❌"},
  TASK_PAUSE_REASONS: {label:"Justificativas de Pausa",module:"🔨 Serviços Internos", icon:"⏸️"},
  FEED_PAUSE_REASONS: {label:"Justificativas de Pausa de Fornecimento",module:"Pecuária", icon:"🥣"},
  VET_PAUSE_REASONS: {label:"Justificativas de Pausa do Atendimento",module:"🏥 Veterinário", icon:"⏸️"},
};

const SYSTEM_LISTS_KEY = "fz:systemLists";
const SYSTEM_LISTS_GLOBAL_KEY = "fz:global:systemLists";


const DATE_DEPENDENT_SYSTEM_LIST_KEYS = new Set([
  // manter fora da ordenação alfabética global quando a lógica do app depender de sequência temporal/numérica própria
]);


function extractObjectLabel(entry) {
  if (!entry || typeof entry !== "object") return "";
  return String(
    entry.name
    || entry.label
    || entry.title
    || entry.breed
    || entry.code
    || entry.typeName
    || entry.categoryName
    || entry.costCenter
    || entry.hour
    || ""
  ).trim();
}

function sortByParentThenName(items, parentGetter, nameGetter) {
  return [...items].sort((a, b) => {
    const parentCmp = compareAlpha(parentGetter(a), parentGetter(b));
    if (parentCmp !== 0) return parentCmp;
    return compareAlpha(nameGetter(a), nameGetter(b));
  });
}

function sortSystemListItems(listKey, items) {
  if (!Array.isArray(items)) return items;
  if (DATE_DEPENDENT_SYSTEM_LIST_KEYS.has(String(listKey || ""))) return items;
  if (items.length <= 1) return items;

  if (items.every(item => typeof item === "string" || item == null)) {
    return [...items].sort((a, b) => compareAlpha(a, b));
  }

  switch (String(listKey || "")) {
    case "CATALOG_PRODUCT_CATEGORIES":
      return sortByParentThenName(items, (item) => item?.typeName || item?.type, (item) => item?.name || item?.label);
    case "CATALOG_PRODUCT_SUBCATEGORIES":
      return sortByParentThenName(items, (item) => item?.categoryName || item?.category, (item) => item?.name || item?.label);
    case "COST_CENTER_CODES":
      return [...items].sort((a, b) => compareAlpha(a?.name || a?.label || a?.costCenter, b?.name || b?.label || b?.costCenter));
    case "FIN_CHART_ACCOUNTS":
      return sortByParentThenName(items, (item) => item?.costCenter, (item) => item?.name || item?.label);
    case "MACH_BRAND_LINKS":
      return [...items].sort((a, b) => {
        const parse = (value) => String(value || "").split(">").map(part => part.trim());
        const [aParent, aChild, aName] = parse(a);
        const [bParent, bChild, bName] = parse(b);
        return compareAlpha(aParent, bParent)
          || compareAlpha(aChild, bChild)
          || compareAlpha(aName, bName);
      });
    default:
      if (items.every(item => item && typeof item === "object")) {
        return [...items].sort((a, b) => compareAlpha(extractObjectLabel(a), extractObjectLabel(b)));
      }
      return items;
  }
}

function sortSystemListsPayload(payload) {
  if (!payload || typeof payload !== "object") return payload;
  return Object.fromEntries(
    Object.entries(payload).map(([key, value]) => [key, sortSystemListItems(key, value)])
  );
}

function normalizeSystemListsPayload(payload) {
  if (!payload || typeof payload !== "object") return { ...SYSTEM_LISTS_DEFAULTS };
  const normalized = sortSystemListsPayload({ ...SYSTEM_LISTS_DEFAULTS, ...payload });
  const normalizedCatalogTypes = Array.from(new Set(
    (Array.isArray(payload?.CATALOG_PRODUCT_TYPES) && payload.CATALOG_PRODUCT_TYPES.length
      ? payload.CATALOG_PRODUCT_TYPES
      : Array.isArray(payload?.PURCHASE_CATS) && payload.PURCHASE_CATS.length
        ? payload.PURCHASE_CATS
        : Array.isArray(payload?.STOCK_CATS) && payload.STOCK_CATS.length
          ? payload.STOCK_CATS
          : SYSTEM_LISTS_DEFAULTS.CATALOG_PRODUCT_TYPES || []
    )
      .map(v => String(v || "").trim())
      .filter(Boolean)
  ));
  const sortedCatalogTypes = normalizedCatalogTypes.sort((a, b) => compareAlpha(a, b));
  normalized.CATALOG_PRODUCT_TYPES = sortedCatalogTypes;
  normalized.PURCHASE_CATS = sortedCatalogTypes;
  normalized.STOCK_CATS = sortedCatalogTypes;
  return normalized;
}

export { SYSTEM_LISTS_LABELS, SYSTEM_LISTS_KEY, SYSTEM_LISTS_GLOBAL_KEY, normalizeSystemListsPayload, sortSystemListsPayload, sortSystemListItems };
